import { fork } from 'redux-saga/effects';

// Sagas
import profileSaga from 'Pages/Profile/state/saga';

export default function* rootSaga() {
  yield fork(profileSaga);
}
